// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"3dacc786","355":"601c5370","527":"c10fd3d0"}[chunkId] + ".chunk.js";
};